// libraries
import Slider from "react-slick";

// styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons
import { FaAtom, FaHamburger, FaMedal, FaTruck } from "react-icons/fa";

const Coaches = () => {
  // slider settings
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
  };

  return (
    <>
      <section className='ftco-section'>
        <div className='container'>
          <div className='row justify-content-center mb-3 pb-3'>
            <div className='col-md-12 heading-section text-center'>
              <h2 className='mb-4'>Our Coaches</h2>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Debitis, alias. Iure, doloribus?
              </p>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='row no-gutters ftco-services d-none d-sm-flex'>
            <div className='col-lg-3 text-center d-flex align-self-stretch '>
              <div className='media block-6 services mb-md-0 mb-4'>
                <div className='icon bg-color-1 active d-flex justify-content-center align-items-center mb-2'>
                  <span className='flaticon-shipped'>
                    <FaTruck />
                  </span>
                </div>
                <div className='media-body'>
                  <h3 className='heading'>Lorem, ipsum.</h3>
                  <span>Lorem ipsum dolor sit amet.</span>
                </div>
              </div>
            </div>
            <div className='col-lg-3 text-center d-flex align-self-stretch'>
              <div className='media block-6 services mb-md-0 mb-4'>
                <div className='icon bg-color-2 d-flex justify-content-center align-items-center mb-2'>
                  <span className='flaticon-diet'>
                    <FaHamburger />
                  </span>
                </div>
                <div className='media-body'>
                  <h3 className='heading'>Lorem, ipsum.</h3>
                  <span>Lorem ipsum dolor sit amet.</span>
                </div>
              </div>
            </div>
            <div className='col-lg-3 text-center d-flex align-self-stretch'>
              <div className='media block-6 services mb-md-0 mb-4'>
                <div className='icon bg-color-3 d-flex justify-content-center align-items-center mb-2'>
                  <span className='flaticon-award'>
                    <FaMedal />
                  </span>
                </div>
                <div className='media-body'>
                  <h3 className='heading'>Lorem, ipsum.</h3>
                  <span>Lorem, ipsum dolor.</span>
                </div>
              </div>
            </div>
            <div className='col-lg-3 text-center d-flex align-self-stretch'>
              <div className='media block-6 services mb-md-0 mb-4'>
                <div className='icon bg-color-4 d-flex justify-content-center align-items-center mb-2'>
                  <span className='flaticon-customer-service'>
                    <FaAtom />
                  </span>
                </div>
                <div className='media-body'>
                  <h3 className='heading'>Lorem.</h3>
                  <span>Lorem ipsum dolor sit.</span>
                </div>
              </div>
            </div>
          </div>
          <div className='no-gutters ftco-services d-block d-sm-none'>
            <Slider {...settings} className='m-0'>
              <div className='col-lg-3 text-center d-flex align-self-stretch '>
                <div className='media block-6 services mb-md-0 mb-4'>
                  <div className='icon bg-color-1 active d-flex justify-content-center align-items-center mb-2'>
                    <span className='flaticon-shipped'>
                      <FaTruck />
                    </span>
                  </div>
                  <div className='media-body'>
                    <h3 className='heading'>Lorem, ipsum.</h3>
                    <span>Lorem ipsum dolor sit amet.</span>
                  </div>
                </div>
              </div>
              <div className='col-lg-3 text-center d-flex align-self-stretch'>
                <div className='media block-6 services mb-md-0 mb-4'>
                  <div className='icon bg-color-2 d-flex justify-content-center align-items-center mb-2'>
                    <span className='flaticon-diet'>
                      <FaHamburger />
                    </span>
                  </div>
                  <div className='media-body'>
                    <h3 className='heading'>Lorem, ipsum.</h3>
                    <span>Lorem ipsum dolor sit amet.</span>
                  </div>
                </div>
              </div>
              <div className='col-lg-3 text-center d-flex align-self-stretch'>
                <div className='media block-6 services mb-md-0 mb-4'>
                  <div className='icon bg-color-3 d-flex justify-content-center align-items-center mb-2'>
                    <span className='flaticon-award'>
                      <FaMedal />
                    </span>
                  </div>
                  <div className='media-body'>
                    <h3 className='heading'>Lorem, ipsum.</h3>
                    <span>Lorem, ipsum dolor.</span>
                  </div>
                </div>
              </div>
              <div className='col-lg-3 text-center d-flex align-self-stretch'>
                <div className='media block-6 services mb-md-0 mb-4'>
                  <div className='icon bg-color-4 d-flex justify-content-center align-items-center mb-2'>
                    <span className='flaticon-customer-service'>
                      <FaAtom />
                    </span>
                  </div>
                  <div className='media-body'>
                    <h3 className='heading'>Lorem.</h3>
                    <span>Lorem ipsum dolor sit.</span>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default Coaches;
